
var app = angular.module('directives.masterpassBanner', []);

require('./directives/masterpassBanner.js');
require('./stylesheets/masterpassBanner.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/masterpassBanner/index.js
 ** module id = 183
 ** module chunks = 1
 **/